import styled from "styled-components";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    margin: 0;
  }
`;

export const DeeplinkButton = styled.button`
  display: ${({ theme }) =>
    theme.displayConsentDeeplinkButton ? "flex" : "none"};
  border: 1px solid #23231f;
  padding: 16px 12px 16px 16px;
  height: 56px;
  background: transparent;
  border-radius: 4px;
  color: #23231f;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  width: fit-content;

  @media (hover: hover) {
    &:hover {
      background: #163563;
      color: #f7f7f6;
      border-color: transparent;
    }
  }

  &:focus-visible {
    outline: none;
    background: #163563;
    color: #f7f7f6;
    border-color: transparent;
    box-shadow:
      0 0 0 2px #f7f7f6,
      0 0 0 4px #126de3;
  }
`;

export interface HashSigningInstructionsProps {
  t: HashSigningInstructionsText | undefined;
  isDesktop: boolean;
  transactionId: string;
}

export interface HashSigningInstructionsText {
  instruction: string;
  openCleverbase: string;
}

export default function HashSigningInstructions({
  t,
}: HashSigningInstructionsProps): JSX.Element {
  const translation: HashSigningInstructionsText = t ?? {
    instruction: "",
    openCleverbase: "",
  };

  return (
    <Container data-testid="hash_signing_instruction">
      <p>{translation.instruction}</p>
    </Container>
  );
}

export function HashSigningDeeplinkButton({
  label,
  transactionId,
  isDesktop,
}: {
  label: string;
  transactionId: string;
  isDesktop: boolean;
}): JSX.Element | null {
  if (isDesktop) return null;
  const url: string = `vidua://?transactionId=${transactionId}`;
  return (
    <DeeplinkButton onClick={() => window.open(url, "_self")}>
      {label}
    </DeeplinkButton>
  );
}
